import { UiSuspensefulOutlet } from '@experiences/ui-common';
import React from 'react';

import {
    RegionIntent,
    Services,
} from '../../common/constants/RouteNames';
import { routePaths } from '../../common/constants/routePaths';
import type { UiRouteObject } from '../../container/routeConfigs/UiRouteObject';
import { AiTrustRoutes } from '../aiTrustLayer/AiTrustRoutes';
import { AuditRoutes } from '../audit/AuditRoutes';
import { ExternalAppRoutes } from '../externalApps/ExternalAppRoutes';
import { GovernanceRoutes } from '../governance/GovernanceRoutes';
import { AdminLicenseRoutes } from '../licensing/LicenseRoutes';
import { MailSettingsRoutes } from '../mailSettings/MailSettingsRoutes';
import { OrgManageAccessRoutes } from '../manageAccess/OrgManageAccessRoutes';
import { AdminSettingsRoutes } from '../organizationsettings/AdminSettingsRoutes';
import { OrgConsentRoutes } from '../orgConsent/OrgConsentRoutes';
import { SecurityRoutes } from '../securitySettings/SecurityRoutes';
import { TenantRoutes } from '../tenants/TenantRoutes';
import { UnifiedExportRoutes } from '../unifiedExport/UnifiedExportRoutes';
import { AdminIdentitiesRoutes } from '../users/IdentitiesRoutes';
import { ClusterHealthPortalRoutes } from './ClusterHealthPortal/ClusterHealthPortal';

const OrganizationAdminHome = React.lazy(() => import('../organizationsettings/OrganizationAdminHome'));
const PartitionRegionIntentionComponent = React.lazy(() => import('../regionIntent/PartitionRegionIntention'));

export const OrgAdminRoutes: UiRouteObject = {
    path: routePaths.admin,
    element: <UiSuspensefulOutlet />,
    children: [
        {
            element: <>
                <OrganizationAdminHome />
                <UiSuspensefulOutlet />
            </>,
            children: [
                {
                    index: true,
                    redirectUrls: [ Services ],
                },
                {
                    path: routePaths.adminRegionIntent,
                    redirectUrls: [ RegionIntent ],
                    element: <PartitionRegionIntentionComponent />,
                },
            ],
        },
        AdminIdentitiesRoutes,
        AdminLicenseRoutes,
        SecurityRoutes,
        AuditRoutes,
        ExternalAppRoutes,
        MailSettingsRoutes,
        AdminSettingsRoutes,
        AiTrustRoutes,
        OrgConsentRoutes,
        TenantRoutes,
        OrgManageAccessRoutes,
        GovernanceRoutes,
        UnifiedExportRoutes,
        ClusterHealthPortalRoutes,
    ],
};
